export const LanguageMap = {
  "en": "English",
  "ko": "한국어",
  "es": "Español",
  "ru": "Русский",
  "ja": "日本語",
  "de": "Deutsch",
  "vi": "Tiếng Việt",
  "fr": "Français",
  "mn": "Монгол",
  "zh-CN": "简体中文",
  "zh-TW": "繁體中文"
};